module.exports = __webpack_public_path__ + "img/Drivers_Energy_Water_Needs.e5c0e9ae.jpg";